import { Injectable } from '@angular/core';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private isLoading = false;
  constructor(
  ) { }

  dismiss() {
    if(this.isLoading) {
      $('.loading_wrapper').remove();
      this.isLoading = false;
    }
  }

  loadingShow(message?) {
    if(!this.isLoading) {
      // console.log('loading');
      let default_message = '<div class="loads-ellipsis"><div></div><div></div><div></div><div></div></div>';
      if(message && message == 'loading_2'){
        message = '<div class="loadingio-spinner-dual-ball"><div class="ldio-dualball"><div></div><div></div><div></div></div></div>';
      } else {
        message = message ? message : default_message;
      }
      $('body').append(`<div class="loading_wrapper"><div class="backdrop_loading"></div><div class="loading__content">${message}<p>Cargando...</p></div></div>`);
      this.isLoading = true;
      setTimeout(() => {
        if(this.isLoading) {
          $('.loading_wrapper').remove();
          this.isLoading = false;
        }
      }, 10000000000);
    }
  }
}
